/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Email } from './Email';
import {
    EmailFromJSON,
    EmailFromJSONTyped,
    EmailToJSON,
} from './Email';
import type { FullName } from './FullName';
import {
    FullNameFromJSON,
    FullNameFromJSONTyped,
    FullNameToJSON,
} from './FullName';
import type { Phone } from './Phone';
import {
    PhoneFromJSON,
    PhoneFromJSONTyped,
    PhoneToJSON,
} from './Phone';

/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {FullName}
     * @memberof Contact
     */
    fullName?: FullName;
    /**
     * 
     * @type {Phone}
     * @memberof Contact
     */
    phone?: Phone;
    /**
     * 
     * @type {Email}
     * @memberof Contact
     */
    email?: Email;
}

/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactFromJSON(json: any): Contact {
    return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullName': !exists(json, 'full_name') ? undefined : FullNameFromJSON(json['full_name']),
        'phone': !exists(json, 'phone') ? undefined : PhoneFromJSON(json['phone']),
        'email': !exists(json, 'email') ? undefined : EmailFromJSON(json['email']),
    };
}

export function ContactToJSON(value?: Contact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'full_name': FullNameToJSON(value.fullName),
        'phone': PhoneToJSON(value.phone),
        'email': EmailToJSON(value.email),
    };
}

